import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-672a0a60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ta-dashboard" }
const _hoisted_2 = { class: "search-section" }
const _hoisted_3 = { class: "autocomplete" }
const _hoisted_4 = { class: "icon-hm" }
const _hoisted_5 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_6 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_7 = {
  id: "autocomplete-results",
  class: "autocomplete-results ml-2"
}
const _hoisted_8 = ["innerHTML", "onClick"]
const _hoisted_9 = {
  class: "ma-4",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ma-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"display":"inline"} }, "Investigations")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "ml-3 mt-2 badge"
}
const _hoisted_12 = {
  key: 1,
  class: "contents ma-4"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "left-side" }
const _hoisted_15 = { class: "score-card" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "inv-type" }, "No investigator assigned", -1))
const _hoisted_17 = { class: "small-boxes" }
const _hoisted_18 = { class: "small-box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Routine", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Cause driven", -1))
const _hoisted_21 = { class: "score-card" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "inv-type" }, "Ongoing", -1))
const _hoisted_23 = { class: "small-boxes" }
const _hoisted_24 = { class: "small-box" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Routine", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Cause driven", -1))
const _hoisted_27 = { class: "score-card" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "inv-type" }, "Reply required", -1))
const _hoisted_29 = { class: "small-boxes" }
const _hoisted_30 = { class: "small-box" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Routine", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Cause driven", -1))
const _hoisted_33 = { class: "mt-4 inserted" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"display":"inline"} }, "Investigators")
], -1))
const _hoisted_35 = { class: "ls-table" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "No. of Routine"),
    /*#__PURE__*/_createElementVNode("th", null, "No. of Cause Driven")
  ])
], -1))
const _hoisted_37 = { style: {"text-align":"right"} }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ma-4",
  style: {"display":"flex","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ma-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { style: {"display":"inline"} }, "ATCS Reports")
  ])
], -1))
const _hoisted_40 = {
  key: 0,
  class: "left-side"
}
const _hoisted_41 = { class: "score-card unapproved-form" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "short-description" }, "Unapproved forms", -1))
const _hoisted_43 = { class: "small-boxes" }
const _hoisted_44 = { class: "small-box" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "External Examiner Sign ups", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Appointing of External Examiner", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Termination of External Examiner", -1))
const _hoisted_48 = { class: "score-card practice-without-tc" }
const _hoisted_49 = { class: "last-update-date" }
const _hoisted_50 = { class: "ma-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "short-description" }, "Practices without Trust Coordinator", -1))
const _hoisted_52 = { class: "score-card non-compliant-forms" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "short-description" }, "Non-compliant forms", -1))
const _hoisted_54 = { class: "small-boxes" }
const _hoisted_55 = { class: "small-box" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Part A", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Part B", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "EER", -1))
const _hoisted_59 = { class: "score-card partb-sub-noEE" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "short-description" }, "Part B submitted without an External Examiner", -1))
const _hoisted_61 = { class: "right-side" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"display":"inline"} }, "Investigators")
], -1))
const _hoisted_63 = { class: "ls-table" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "No. of Routine"),
    /*#__PURE__*/_createElementVNode("th", null, "No. of Cause Driven")
  ])
], -1))
const _hoisted_65 = { style: {"text-align":"right"} }

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.loadingDataSet)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          onKeydown: [
            _cache[0] || (_cache[0] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
            _cache[1] || (_cache[1] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
            _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
          ],
          class: "searchField",
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.search) = $event)),
          placeholder: "Search practice name or ID"
        }, null, 544), [
          [_vModelText, _ctx.search]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "hidden",
          id: "practice",
          name: "practice",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.currentSelectedPractice) = $event))
        }, null, 512), [
          [_vModelText, _ctx.currentSelectedPractice]
        ]),
        _createElementVNode("span", _hoisted_4, [
          (_ctx.isSearching)
            ? (_openBlock(), _createElementBlock("i", _hoisted_5))
            : (_openBlock(), _createElementBlock("i", _hoisted_6))
        ]),
        _withDirectives(_createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practiceList, (practice, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]),
              innerHTML: _ctx.highlightWord(_ctx.formatPracticeText(practice)),
              onClick: _withModifiers($event => (_ctx.selectPractice(practice)), ["prevent"])
            }, null, 10, _hoisted_8))
          }), 128))
        ], 512), [
          [_vShow, _ctx.isOpen]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      (!_ctx.loadingDataSet)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.numberOfInvestigations.numberOfCreatedRoutines + _ctx.numberOfInvestigations.numberOfCreatedCauseDrivens +
      _ctx.numberOfInvestigations.numberOfOngoingRoutines + _ctx.numberOfInvestigations.numberOfOngoingCauseDrivens +
      _ctx.numberOfInvestigations.numberOfCompletedRoutines + _ctx.numberOfInvestigations.numberOfCompletedCauseDrivens), 1))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.loadingDataSet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_ctx.numberOfInvestigations)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.numberOfInvestigations.numberOfCreatedRoutines + _ctx.numberOfInvestigations.numberOfCreatedCauseDrivens), 1),
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", null, _toDisplayString(_ctx.numberOfInvestigations.numberOfCreatedRoutines), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_20,
                        _createElementVNode("div", null, _toDisplayString(_ctx.numberOfInvestigations.numberOfCreatedCauseDrivens), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.numberOfInvestigations.numberOfOngoingRoutines + _ctx.numberOfInvestigations.numberOfOngoingCauseDrivens), 1),
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", null, _toDisplayString(_ctx.numberOfInvestigations.numberOfOngoingRoutines), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_26,
                        _createElementVNode("div", null, _toDisplayString(_ctx.numberOfInvestigations.numberOfOngoingCauseDrivens), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.numberOfInvestigations.numberOfCompletedRoutines +
            _ctx.numberOfInvestigations.numberOfCompletedCauseDrivens), 1),
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", null, _toDisplayString(_ctx.numberOfInvestigations.numberOfCompletedRoutines), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_32,
                        _createElementVNode("div", null, _toDisplayString(_ctx.numberOfInvestigations.numberOfCompletedCauseDrivens), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("table", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfInvestigationsPerInvestigator, (i) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(i.trustTeamMember?.displayName), 1),
                          _createElementVNode("td", null, _toDisplayString(i.numberOfRoutines), 1),
                          _createElementVNode("td", null, _toDisplayString(i.numberOfCauseDrivens), 1)
                        ]))
                      }), 256))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("button", {
                      class: "btn btn-primary sml mt-4",
                      onClick: _cache[5] || (_cache[5] = $event => (_ctx.goToTrustTeam()))
                    }, "Go to Trust Team")
                  ])
                ]),
                (!_ctx.loadingDataSet)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _hoisted_39,
                      (_ctx.numberOfInvestigations)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.totalNumberOfUnapprovedForms.eeSignUpForms + _ctx.totalNumberOfUnapprovedForms.appointEeRequestForms +
              _ctx.totalNumberOfUnapprovedForms.terminateEeRequestForms), 1),
                              _hoisted_42,
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _hoisted_45,
                                  _createElementVNode("div", null, _toDisplayString(_ctx.totalNumberOfUnapprovedForms.eeSignUpForms), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_46,
                                  _createElementVNode("div", null, _toDisplayString(_ctx.totalNumberOfUnapprovedForms.appointEeRequestForms), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_47,
                                  _createElementVNode("div", null, _toDisplayString(_ctx.totalNumberOfUnapprovedForms.terminateEeRequestForms), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _createTextVNode("Data as of: "),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.totalNumberOfPracticeWithoutTC.updatedOn), 1)
                              ]),
                              _createElementVNode("h3", _hoisted_50, _toDisplayString(_ctx.totalNumberOfPracticeWithoutTC.practiceWithoutTrustCoordinator), 1),
                              _hoisted_51
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.totalNumberOfComplaintForms.nonCompliantPartA + _ctx.totalNumberOfComplaintForms.nonCompliantPartB +
              _ctx.totalNumberOfComplaintForms.nonCompliantEeReport), 1),
                              _hoisted_53,
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  _hoisted_56,
                                  _createElementVNode("div", null, _toDisplayString(_ctx.totalNumberOfComplaintForms.nonCompliantPartA), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_57,
                                  _createElementVNode("div", null, _toDisplayString(_ctx.totalNumberOfComplaintForms.nonCompliantPartB), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_58,
                                  _createElementVNode("div", null, _toDisplayString(_ctx.totalNumberOfComplaintForms.nonCompliantEeReport), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.totalNumberOfComplaintForms.partBSubmittedNoExternalExaminer), 1),
                              _hoisted_60
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("table", _hoisted_63, [
              _hoisted_64,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfInvestigationsPerInvestigator, (i) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(i.trustTeamMember?.displayName), 1),
                    _createElementVNode("td", null, _toDisplayString(i.numberOfRoutines), 1),
                    _createElementVNode("td", null, _toDisplayString(i.numberOfCauseDrivens), 1)
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("button", {
                class: "btn btn-primary sml mt-4",
                onClick: _cache[6] || (_cache[6] = $event => (_ctx.goToTrustTeam()))
              }, "Go to Trust Team")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}